import WidgetTemplate from './WidgetTemplate';
import './WidgetTemplate.scss';

export default WidgetTemplate;
